import { cn } from "@minket/ui/lib/utils";
import type * as React from "react";

/**
 * A key cap: the mono at 12 px on paper, a hairline edge with a 2 px foot so it reads as a key,
 * square corners. On the rail it takes the rail's colours.
 */
function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        "pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-sm border border-b-2 bg-background px-[5px] font-mono text-xs leading-none text-muted-foreground select-none",
        "[&_svg:not([class*='size-'])]:size-3",
        className,
      )}
      {...props}
    />
  );
}

function KbdGroup({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="kbd-group"
      className={cn("inline-flex items-center gap-1", className)}
      {...props}
    />
  );
}

export { Kbd, KbdGroup };
